/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'ai-summary-label': 'Sammanfatta',
  'copy-content-link-label': 'Kopiera länk',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Börja skriva för att söka efter en etikett',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Alla',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtrera sökning efter produkt',
  'dynamic-cards-search-page.atlas.for': 'för',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Kalender',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Delta i mötet',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Möteslänk',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Delta i mötet',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Tidigare händelser',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Återkommande händelse',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Återkommande',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Kommande händelser',
  'dynamic-cards-search-page.compass.owner-name': 'Ägs av {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Nivå {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Hitta innehåll',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Valda',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Föreslagna',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Valda',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Föreslagna',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Hitta personer',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Valda',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Hitta etiketter',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Hitta utrymmen',
  'dynamic-cards-search-page.connect_third_party_product_description': 'Anslut ditt konto för att se saknade resultat',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Din administratör har lagt till {product}!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} är nu tillgänglig!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'Från-datum måste infalla före till-datum',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'Från-datum får inte vara i framtiden',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today':
    'Till-datum får inte vara ett datum i framtiden',
  'dynamic-cards-search-page.date.filter.last.month': 'De senaste 30 dagarna',
  'dynamic-cards-search-page.date.filter.last.week': 'De senaste 7 dagarna',
  'dynamic-cards-search-page.date.filter.last.year': 'Det senaste året',
  'dynamic-cards-search-page.document-search-result.google-slides-label': 'Bilder',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Skapa svar',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Senaste',
  'dynamic-cards-search-page.error_primary': 'Vi har problem med sökningen',
  'dynamic-cards-search-page.error_secondary': 'Det var nog bara tillfälligt. Testa att <btn>försöka igen</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Externa personer #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Rensa filter',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'När som helst',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'De senaste 30 dagarna',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'De senaste 7 dagarna',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Det senaste året',
  'dynamic-cards-search-page.filter.last.updated.today': 'I dag',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'I går',
  'dynamic-cards-search-page.filter.type.answer': 'Svar',
  'dynamic-cards-search-page.filter.type.attachment': 'Bilagor',
  'dynamic-cards-search-page.filter.type.blogpost': 'Blogginlägg',
  'dynamic-cards-search-page.filter.type.branch': 'Grenar',
  'dynamic-cards-search-page.filter.type.calendar': 'Kalendrar',
  'dynamic-cards-search-page.filter.type.comment': 'Kommentarer',
  'dynamic-cards-search-page.filter.type.commit': 'Incheckningar',
  'dynamic-cards-search-page.filter.type.component': 'Komponenter',
  'dynamic-cards-search-page.filter.type.conversation': 'Konversationer',
  'dynamic-cards-search-page.filter.type.database': 'Databaser',
  'dynamic-cards-search-page.filter.type.design': 'Designer',
  'dynamic-cards-search-page.filter.type.documents': 'Dokument',
  'dynamic-cards-search-page.filter.type.embed': 'Smarta länkar',
  'dynamic-cards-search-page.filter.type.folder': 'Mappar',
  'dynamic-cards-search-page.filter.type.goal': 'Målsättningar',
  'dynamic-cards-search-page.filter.type.issue': 'Ärenden',
  'dynamic-cards-search-page.filter.type.message': 'Meddelanden',
  'dynamic-cards-search-page.filter.type.page': 'Sidor',
  'dynamic-cards-search-page.filter.type.placeholder': 'Hitta typ',
  'dynamic-cards-search-page.filter.type.presentation': 'Presentationer',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull-begäranden',
  'dynamic-cards-search-page.filter.type.question': 'Frågor',
  'dynamic-cards-search-page.filter.type.repository': 'Lagringsplatser',
  'dynamic-cards-search-page.filter.type.space': 'Utrymmen',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Utrymmeskalendrar',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Kalkylblad',
  'dynamic-cards-search-page.filter.type.video': 'Videor',
  'dynamic-cards-search-page.filter.type.web-page': 'Webbplatser',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Whiteboardtavlor',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Rensa alla',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filter',
  'dynamic-cards-search-page.filters.names.content': 'Innehåll under',
  'dynamic-cards-search-page.filters.names.contributor': 'Medarbetare',
  'dynamic-cards-search-page.filters.names.labels': 'Etikett',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Matchande titel',
  'dynamic-cards-search-page.github-branch-result.label': 'Gren',
  'dynamic-cards-search-page.github-commit-result.label': 'Skicka',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull-begärande',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Sök efter vad som helst',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Hitta projekt',
  'dynamic-cards-search-page.landing_primary': 'Kom igång med filter för dynamiska kort',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Dokument',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Ark',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Vi hittade inget som matchade din sökning',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Det verkar som att du använder filter. Pröva att rensa dem.',
  'dynamic-cards-search-page.nouns.goal': 'Mål',
  'dynamic-cards-search-page.nouns.goals': 'Mål',
  'dynamic-cards-search-page.nouns.tag': 'Tagg',
  'dynamic-cards-search-page.nouns.tags': 'Taggar',
  'dynamic-cards-search-page.number_of_results': 'Visar {numberOfResults,number} av {totalCount,number} resultat',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Auktorisering för {product} misslyckades.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Auktorisering för {product} lyckades.',
  'dynamic-cards-search-page.oauth-message-connect': 'Anslut',
  'dynamic-cards-search-page.products.custom-website': 'Webbplats',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Sortera efter skapade (nyast först)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Skapade (nyast först)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Uppdaterade (nyast först)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Sortera efter uppdaterade (nyast först)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Ändra sortering i listan',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Nästa',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filtrera efter produkt för att få fler relevanta sökresultat.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Sök i företagets samtliga arbetsområden',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Alternativen ändras i syfte att ge dig specifika resultat beroende på vilken produkt du filtrerar.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Hitta exakt det du letar efter',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Bilaga',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Bifogades {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Ljud',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Bild',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Uppdaterades {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Privat kanal',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Ikon för borttagning av de senaste sökningarna',
  'dynamic-cards-search-page.search-result.repository-label': 'Lagringsplats',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Gruppmeddelande med externa användare} =2 {{name1} och {name2}} =3 {{name1}, {name2} och {name3}} =4 {{name1}, {name2}, {name3} och {overflowContributorCount} till} one {{name1}} other {{name1}, {name2}, {name3} och {overflowContributorCount} till}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'okänd-kanal',
  'dynamic-cards-search-page.search_result_type_answer': 'Svar',
  'dynamic-cards-search-page.search_result_type_card': 'Kort',
  'dynamic-cards-search-page.search_result_type_component': 'Komponent',
  'dynamic-cards-search-page.search_result_type_document': 'Dokument',
  'dynamic-cards-search-page.search_result_type_embed': 'Smart länk',
  'dynamic-cards-search-page.search_result_type_folder': 'Mapp',
  'dynamic-cards-search-page.search_result_type_presentation': 'Presentation',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull-begärande',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'SharePoint-dokument',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Utrymmeskalender',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Kalkylblad',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Okänd',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Din administratör har lagt till <strong>{product}!</strong>{br} Anslut ditt konto för att se saknade resultat, inklusive dokument som bara du har tillgång till.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} är nu tillgänglig!</strong>{br} Anslut ditt konto för att se saknade resultat, inklusive dokument som bara du har tillgång till.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Godkänn',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'Auktorisering för {product} misslyckades.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'Auktorisering för {product} lyckades.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtrera efter alla appar',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtrera efter fler appar',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Arkiverad',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'I riskzonen',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Avbröts',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Slutfört',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Ej enligt plan',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Enligt plan',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Pausad',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Väntar',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} kapitel i den här videon} other {{chapterCount,number} kapitel i den här videon}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'videoikon',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Videominiatyr',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'har tilldelats',
  'dynamic-cards-search-page.work-item-creator.created': 'skapade',
  'dynamic-cards-search-page.work-item-status.for': 'för',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ärende',
  'dynamic-cards-search-page.work-item.label': 'Arbetsuppgift',
  'initialsAvatar.label': 'Avatar med initialer',
  'personAvatar.label': 'Personavatar',
  'search-page.results.private-result-label': 'Privat',
  'search-page.results.private-result-tooltip': 'Visas bara för dig',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmar}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Kanal',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Kanal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} medlem} other {{count,number} medlemmar}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Senast aktiv {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'okänd-kanal',
  'search-page.results.product-results.third-party.external-people-label': 'Externa personer',
  'search-page.results.product-results.third-party.external-person-label': 'Extern person',
  'search-page.results.product-results.third-party.last-active': 'Senast aktiv {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Meddelande',
  'search-page.results.product-results.third-party.no-contributors-label': 'Externa personer i #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} i en privat konversation',
  'search-page.results.product-results.third-party.thread-type-label': 'Tråd',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} i #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} och {remainingContributorsCount} till} other {{title} och {remainingContributorsCount} till}}',
  'search-page.results.restricted-result-label': 'Begränsad',
  'search-page.results.restricted-result-tooltip': 'Visas bara för specifika personer',
  'search-page.show-more-breadcrumbs-button-label': 'Visa fler länkstigar',
  'search-page.verified-icon-label': 'Verifierad',
  'search-page.verified-icon-tooltip-message': 'Sidan har verifierats av en ägare eller administratör.',
  'search-result.result.count': '{count, plural, one {Visar {count} resultat} other {Visar {count} resultat}}',
  'search-result.user-mention.external-person': 'Extern person',
};
